/**
 * Re-export to prevent massive changes
 * TODO: TECH DEBT, remove dependencies from this path in favor of class inside '@controls' module once migration is completed
 */
export {
  ControlValidatorPluginToken,
  DecoratedControlValidatorPluginToken,
  ControlConfigTuple,
  ControlValidatorPlugin,
} from '@controls/model/control-validator-plugin';
export { AbstractControlValidatorPlugin } from '@controls/core/control-validator-plugin-template';
